var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-32.3%",
    y: "-23.1%",
    width: "164.6%",
    height: "164.6%",
    filterUnits: "objectBoundingBox",
    id: "na982svuha"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.227070444 0 0 0 0 0.870782382 0 0 0 0 0.731379797 0 0 0 0.2 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "d3uszh8xdb",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#na982svuha)",
    xlinkHref: "#d3uszh8xdb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d3uszh8xdb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.219 19.203h37.578v37.578H26.219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.402 30.163H59.1c.864 0 1.565.701 1.565 1.566v18.79c0 .864-.7 1.565-1.565 1.565H30.916a1.566 1.566 0 0 1-1.566-1.566V25.466c0-.865.701-1.566 1.566-1.566h23.486v6.263zm-21.92 3.132v15.657h25.052V33.295H32.482zm0-6.263v3.131H51.27v-3.131H32.48zm17.223 12.526h4.697v3.131h-4.697v-3.131z",
    fill: "#48DCBA",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBlock);
export default __webpack_public_path__ + "static/media/wallet-block.4f68ba1522012109e3090d173570e5b6.svg";
export { ForwardRef as ReactComponent };